<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <form id="FormArticulosWeb" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">

                        <div class="row row-cols-1 row-cols-md-3 g-4">

                          <div class="col" >
                                <div class="card h-100">
                                    <div class="card-body" >
                                        <h6>Materiales</h6>
                                        <hr style="background-color:gray !important;">
                                        <div class="row" style="overflow-Y: scroll; ">
                                            <div v-for="(material,index) in ListaMateriales" style="cursor: pointer;" class="col-lg-12" :key="'mat_'+index"  v-bind:class="material.Marcado == 'SI'? 'col-lg-12 activeMaterial': 'col-lg-12' ">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" @change="saveArtixMaterial(material)" v-model="articuloxmateriales" :value="material.IdMaterial" :id="'chmat_'+material.IdMaterial" :disabled="blockChkMaterial">
                                                    <label class="form-check-label" @click="selectedMaterial(material)">{{ material.Nombre }} ({{ material.Clave }})</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col"> 
                                <div class="card h-100">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-12"><h6>Graduaciones al Material: {{ MaterialSelected.Nombre }}</h6></div>
                                        </div>
                                         
                                        <hr style="background-color:gray !important;">

                                        <div class="form-group row">
                                            <div class="col-12 col-lg-4 col-xl-4">
                                                <label></label>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4 text-center">
                                                <label>Valor Inicial</label>
                                            </div>
                                            
                                            <div class="col-6 col-lg-4 col-xl-4 text-center">
                                                <label>Valor Final</label>
                                            </div>

                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-lg-4 col-xl-4">
                                                <h6>Esfera</h6>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.EsferaI" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(esfera,index1) in RangoEsferas" :key="index1" :value="esfera.Valor"> <template v-if="parseFloat(esfera.Valor) > 0">+</template>{{ esfera.Valor }}</option>
                                                </select>
                                                <CValidation v-if="this.errorvalidacion.EsferaI" :Mensaje="'*'+errorvalidacion.EsferaI[0]"/>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.EsferaD" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(esfera,index2) in RangoEsferas" :key="index2" :value="esfera.Valor"> <template v-if="parseFloat(esfera.Valor) > 0">+</template>{{ esfera.Valor }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-lg-4 col-xl-4">
                                                <h6>Cilindro</h6>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.CilindroI" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(cilindro,index3) in RangoCilindros" :key="index3" :value="cilindro.Valor">{{ cilindro.Valor }}</option>
                                                </select>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.CilindroD" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(cilindro,index4) in RangoCilindros" :key="index4" :value="cilindro.Valor">{{ cilindro.Valor }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-lg-4 col-xl-4">
                                                <h6>Adicionales</h6>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.AdicionalI" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(adiccion,index5) in RangoAdicionales" :key="index5" :value="adiccion.Valor"> <template v-if="parseFloat(adiccion.Valor) > 0">+</template>{{ adiccion.Valor }}</option>
                                                </select>
                                            </div>
                                            <div class="col-6 col-lg-4 col-xl-4">
                                                <select class="form-select" v-model="articuloxGraduaciones.AdicionalD" :disabled="blockGraduaciones">
                                                    <option value="">Seleccionar limite</option>
                                                    <option v-for="(adiccion,index6) in RangoAdicionales" :key="index6" :value="adiccion.Valor"> <template v-if="parseFloat(adiccion.Valor) > 0">+</template>{{ adiccion.Valor }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <hr style="background-color:gray !important;">

                                        <div class="form-group row">
                                            <div class="col-12 col-lg-6">
                                                <label>Limite Esfera</label>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <select class="form-select" v-model="articuloxGraduaciones.LimiteEsfera" :disabled="blockGraduaciones">
                                                    <option value="N/A">N/A</option>
                                                    <option v-for="(esfera,index7) in RangoEsferas" :key="index7" :value="esfera.Valor"> <template v-if="parseFloat(esfera.Valor) > 0">+</template>{{ esfera.Valor }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-lg-6">
                                                <label>Limite Esfera + Adicion</label>
                                            </div>

                                            <div class="col-12 col-lg-6">
                                                <select class="form-select" v-model="articuloxGraduaciones.LimiteAdicion" :disabled="blockGraduaciones">
                                                    <option value="N/A">N/A</option>
                                                    <option v-for="(esfera,index8) in RangoEsferas" :key="index8" :value="esfera.Valor"> <template v-if="parseFloat(esfera.Valor) > 0">+</template>{{ esfera.Valor }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <hr style="background-color:gray !important;">
                                        <div class="form-group row">
                                            <div class="col-12 text-end"><button class="btn btn-warning btn-sm" @click="saveArtixGraduaciones()"> Guardar</button></div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            
                            <div class="col">
                                <div class="card h-100">
                                    <div class="card-body" >
                                        <h6>Protecciones</h6>
                                        <hr style="background-color:gray !important;">
                                        <div class="row" style="overflow-Y: scroll; max-height: 350px;">
                                            <div v-for="(proteccion,indx) in ListaProtecciones" style="cursor: pointer;" class="col-lg-12" :key="'mat_'+indx">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" @change="saveArtixProtecciones(proteccion)" v-model="articuloxprotecciones" :value="proteccion.IdProteccion" :id="'chmat_'+proteccion.IdProteccion" :disabled="blockProtecciones">
                                                    <label class="form-check-label">{{ proteccion.Nombre }} ({{ proteccion.Clave }})</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </template>
            </CLoader>
        </template>
    </Clist>
    
</template>
<script>
const EmitEjecuta = 'seccionArticulosxMateriales';

export default{
    name: 'FormArticuloxMateriales',
    props: ['pObjArticuloWeb'],
    data(){
        return{
            ConfigList:{
                Title: 'Configuracion de Materiales',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            segurity: {},
            errorvalidacion: [],
            OrigenList: '',

            ArticuloWeb:{

            },
            ListaMateriales:[],
            ListaProtecciones:[],
            RangoEsferas:[],
            RangoCilindros:[],
            RangoAdicionales:[],
            MaterialSelected:{
                Nombre:'',
                Clave:''
            },

            blockChkMaterial: false,
            blockGraduaciones: true,
            blockProtecciones: true,

            //v-MODELS
            articuloxmateriales:[],
            articuloxprotecciones:[],
            articuloxGraduaciones:{
                IdArticuloxGraduacion: 0,
                IdArticuloWeb: 0,
                IdMaterial: 0,
                EsferaI: "",
                EsferaD: "",
                CilindroI: "",
                CilindroD: "",
                AdicionalI: "",
                AdicionalD: "",
                LimiteEsfera: "N/A",
                LimiteAdicion: "N/A"
            }
        }

    },
    methods:{

        limpiarGradxProtecciones() {

            this.MaterialSelected = {
                IdMaterial: 0,
                Nombre:'',
                Clave:''
            };

            this.articuloxprotecciones = [];

            this.articuloxGraduaciones = {
                IdArticuloxGraduacion: 0,
                IdArticuloWeb: 0,
                IdMaterial: 0,
                EsferaI: "",
                EsferaD: "",
                CilindroI: "",
                CilindroD: "",
                AdicionalI: "",
                AdicionalD: "",
                LimiteEsfera: "N/A",
                LimiteAdicion: "N/A"
            };
        },

        limpiaGraduaciones(){
            this.articuloxGraduaciones = {
                IdArticuloxGraduacion: 0,
                IdArticuloWeb: 0,
                IdMaterial: 0,
                EsferaI: "",
                EsferaD: "",
                CilindroI: "",
                CilindroD: "",
                AdicionalI: "",
                AdicionalD: "",
                LimiteEsfera: "N/A",
                LimiteAdicion: "N/A"
            };
        },

        async getConfigMateriales() {
            
            this.ConfigList.ShowLoader = true;
            let newRequest = {
                IdArticuloWeb: this.ArticuloWeb.IdArticuloWeb,
            };

            await this.$http.post('getarticulosxmateriales',newRequest)
            .then((res)=>{
                this.ListaMateriales  = res.data.data.Materiales.map(item => ({
                    IdMaterial: item.IdMaterial,
                    Nombre: item.Nombre,
                    Clave: item.Clave,
                    Marcado: 'NO'
                }));
                this.articuloxmateriales = res.data.data.MaterialxArticulo;
                this.ListaProtecciones  = res.data.data.Protecciones;
                this.RangoEsferas       = res.data.data.Esferas;
                this.RangoCilindros     = res.data.data.Cilindros;
                this.RangoAdicionales   = res.data.data.Adicionales;

            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },


        selectedMaterial(item) {
            this.ListaMateriales.forEach(item => item.Marcado = 'NO');

            let isSaved = this.articuloxmateriales.filter( (id) => id == item.IdMaterial);

            if(isSaved.length > 0 ) { // SE COMPRUEBA SI EXISTE DICHO MATERIAL EN EL ARREGLO DE LA BD
                this.MaterialSelected = item;
                let search = this.ListaMateriales.findIndex((material) => material.IdMaterial == item.IdMaterial);
                if (search != undefined) {
                    this.ListaMateriales[search].Marcado = 'SI';
                }
                this.limpiaGraduaciones();
                this.recoveryConfig(item.IdMaterial);
                this.blockGraduaciones = false;
                this.blockProtecciones = false;
            }else{
                console.log('No exite en el arreglo')
                this.blockGraduaciones = true;
                this.blockProtecciones = true;
                this.limpiarGradxProtecciones();
            }
        },


        async recoveryConfig(id){
            
            let newRequest = {
                IdArticuloWeb: this.ArticuloWeb.IdArticuloWeb,
                IdMaterial: id
            };
            
            await this.$http.post('getconfigartxmat',newRequest)
            .then((res)=>{
                if(res.data.data.Graduaciones != undefined) { this.articuloxGraduaciones = res.data.data.Graduaciones; }
                if(res.data.data.Protecciones != undefined) { this.articuloxprotecciones = res.data.data.Protecciones; }
                
            }).catch(() => {
                
            })
            .finally(()=>{
                
            });
        },

        async saveArtixMaterial(material) {
            let newRequest = {
                IdArticuloWeb: this.ArticuloWeb.IdArticuloWeb,
                IdMaterial: material.IdMaterial
            };
            this.blockChkMaterial   = true;

            let isSaved = this.articuloxmateriales.filter( (id) => id == material.IdMaterial);

            if( isSaved.length > 0 ) {
                //console.log('Guardando material')
                await this.$http.post('addarticulosxmateriales',newRequest)
                .then((res)=>{
                    console.log(res.data);

                }).finally(()=>{
                    this.blockChkMaterial = false;
                });
                
            }else {
                //console.log('Eliminando material')
                await this.$http.post('delarticulosxmateriales',newRequest)
                .then((res)=>{
                   this.limpiarGradxProtecciones();

                }).finally(()=>{
                    this.blockChkMaterial = false;
                });
            }  
        },


        async saveArtixGraduaciones() {

            this.articuloxGraduaciones.IdArticuloWeb    = this.ArticuloWeb.IdArticuloWeb;
            this.articuloxGraduaciones.IdMaterial       = this.MaterialSelected.IdMaterial;
            
            //console.log('guardando graduaciones');
            this.blockGraduaciones = true;
            this.errorvalidacion    = [];
            await this.$http.post('articulosxgraduaciones', this.articuloxGraduaciones)
            .then((res)=> {

                if(res.data.status == true){
                    this.articuloxGraduaciones = res.data.data;
                    this.$toast.success('Graduaciones Guardadas');
                }
                

            }).catch( err => {
                if(err.response.data.errors){
                    this.errorvalidacion = err.response.data.errors;
                    this.$toast.warning('Completa los campos');
                }
                else{
                    this.$toast.error(err.response.data.message);
                }
            })
            .finally(()=>{
                this.blockGraduaciones = false;

                
            });

        },

        async saveArtixProtecciones(proteccion){
            let newRequest = {
                IdArticuloWeb: this.ArticuloWeb.IdArticuloWeb,
                IdMaterial: this.MaterialSelected.IdMaterial,
                IdProteccion: proteccion.IdProteccion
            };

            this.blockProtecciones = true;

            let isSaved = this.articuloxprotecciones.filter( (id) => id == proteccion.IdProteccion);

            if( isSaved.length > 0 ) {
                //console.log('Guardando proteccion')
                await this.$http.post('addarticulosxprotecciones',newRequest)
                .then((res)=>{
                    //console.log(res.data);

                }).finally(()=>{
                    this.blockProtecciones = false;
                });
                
            }else {
                //console.log('Eliminando proteccion')
                await this.$http.post('delarticulosxprotecciones',newRequest)
                .then((res)=>{
                   
                    //console.log(res.data);
                }).finally(()=>{
                    this.blockProtecciones = false;
                });
            }
        },

        Regresar() {
           
            switch (this.OrigenList) {
                case 'progressive':
                    let tpLente = ( sessionStorage.getItem('objTipoLente') != undefined ) ? JSON.parse(sessionStorage.getItem('objTipoLente')) : '';
                    let sublinea = ( sessionStorage.getItem('objSublinea') != undefined ) ? JSON.parse(sessionStorage.getItem('objSublinea')) : '';

                     console.log('Intentando Regresar articulosweb')
                     
                    if(tpLente != undefined && sublinea != undefined) {
                        this.$router.push({name:'articulosweb',params:{pObjTipoLente:tpLente,pObjSublinea:sublinea}});
                    }else {
                        this.$router.push({name:'tiposlentes',params:{}});
                        console.log('not found data!!');
                    }
                    
                    break;

                case 'Lends':
                    this.$router.push({name:'tipolentexsublinea',params:{pObjEnviado:this.ObjTipoLente}});
                    break;
            
                default:
                    this.$router.push({name:'tiposlentes',params:{}});
                    break;
            }
            
        },

    },
    created() {

        this.bus.$off('EmitReturn');
        
        if(sessionStorage.getItem('OrigenList') != undefined) {
            this.OrigenList = sessionStorage.getItem('OrigenList');
        }

        if(this.pObjArticuloWeb != undefined) {
            this.ArticuloWeb = this.pObjArticuloWeb;
            sessionStorage.setItem('objArticuloweb',JSON.stringify(this.ArticuloWeb));

        }else if ( sessionStorage.getItem('objArticuloweb') != undefined ){
            this.ArticuloWeb = JSON.parse(sessionStorage.getItem('objArticuloweb'));

        }

        this.getConfigMateriales();
        this.ConfigList.Title = this.ConfigList.Title+' para: '+this.ArticuloWeb.Nombre;
        this.ConfigLoad.ShowLoader = false;

    }, 
    mounted () {
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
     
}
</script>
<style>
.activeMaterial {
    background-color: #c3c1c1;
    /* font-size: 21px; */
    height: 38px;
    font-size: 18px;
    font-weight: bold;
}
</style>
   
